var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"position":"absolute","width":"87%","height":"100%","overflow":"hidden","border-radius":"4px","box-shadow":"0px 6px 18px rgba(0, 0, 0, 0.06)"},attrs:{"src":_vm.link,"frameborder":"0","allowFullScreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }